import React, { Component } from "react";
import { Link } from "react-router-dom";
class CityXAppNewBusiness_SiteContent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="themesflat-row equalize sm-equalize-auto clearfix">
            <div className=" clearfix">
              <div className="themesflat-headings style-1 clearfix">
                <div className="sup-heading">CityX App</div>
                <h5 className="title">
                  Želite dopuniti ili promjeniti podatke o poslovnom subjekutu?
                </h5>
                <div className="sep has-width w80 accent-bg margin-top-20 margin-bottom-30 clearfix" />
                <p className="">
                  <b>
                    Uočio si krivi podatak u aplikaciji? Ili želiš dodati neku
                    važnu informaciju? Javi nam se i predloži! S obzirom da
                    vodimo brigu da su nam svi podatci točni i ažurirani,
                    zahvaljujemo na svakoj sugestiji.{" "}
                  </b>
                  <br />
                  <br />
                  <b>KAKO IZMIJENITI/ DOPUNITI PODATKE U CITYX APLIKACIJI?</b>
                  <br />
                  <br />
                  Dovoljno je putem obrasca u nastavku ispuniti
                  kategorije/rubrike u kojima ste uočili nepravilnost ili ih
                  samo želite dopuniti. Naš tim koji vodi brigu o sadržaju
                  aplikacije javit će se povratno u što kraćem roku s
                  informacijom jesu li izmjene prihvaćene. Ukoliko se radi o
                  informacijama koje zahtijevaju formu kraćeg teksta (do 1500
                  znakova), bitno je tekst kvalitetno napisati kako bi
                  ponuda/usluga što bolje bila prezentirana krajnjem kupcu. Za
                  sva pitanja/nedoumice, možete nas kontaktirati i putem mail
                  adrese info@cityx.hr.
                </p>
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={39}
            data-mobile={39}
            data-smobile={39}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <p style={{ padding: "0px" }}>
              <iframe
                src="https://forms.monday.com/forms/embed/981810cca442eec081204fb0ea7e94fb?r=use1"
                width={"100%"}
                style={{
                  width: "200%",
                  height: "1000px",
                }}
              ></iframe>
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={37}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="flat-content-wrap style-2 clearfix">
            <div className="item">
              <div className="inner">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={10}
                  data-mobile={10}
                  data-smobile={10}
                />
              </div>
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default CityXAppNewBusiness_SiteContent;
